import React, { useState } from "react";
import {
	Modal,
	ModalBody,
	ModalHeader,
	ModalFooter,
	Spinner,
} from "reactstrap";
import {
	bookingService,
} from "../../../../../../services";

// Confirms "Ready for Dispatch": stops the prepare timer, booking is dispatched later
const ReadyDispatchModal = (props) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const modalClose = (flag) => {
		setError("");
		props.readyDispatchModalClose(flag);
	};

	const handleReadyForDispatch = async () => {
		const user = JSON.parse(localStorage.getItem("user"));
		setLoading(true);
		setError("");
		try {
			const response = await bookingService.doReadyForDispatch({
				bookingId: props.bookingId,
				log_by_id: user.data._id,
			});
			if (Number(response?.status) === 200) {
				modalClose(true);
			} else {
				setError(response?.data?.errors?.common?.[0] || "There is some server error.");
			}
		} catch (errors) {
			// 400 rejects with data.errors
			setError(errors?.common?.[0] || "There is some server error.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			size="md"
			backdrop="static"
			centered
			isOpen={props.readyDispatchModal}
			toggle={() => modalClose(false)}
		>
			<ModalHeader toggle={() => modalClose(false)}>
				Ready for Dispatch
			</ModalHeader>
			<ModalBody>
				Are you sure this booking is ready for dispatch? The preparation timer will stop now.
				{error && <div className="text-danger mt-2">{error}</div>}
			</ModalBody>
			<ModalFooter>
				<div className="">
					<button
						onClick={() => modalClose(false)}
						className="btn btn-secondary mr-2"
						data-dismiss="modal"
					>
						Cancel
					</button>
					{!loading && (
						<button
							className="btn btn-primary"
							onClick={handleReadyForDispatch}
						>
							Ok
						</button>
					)}
					{loading && (
						<button
							className="btn btn-primary loader-icon"
							disabled
						>
							<Spinner className="img-svg"></Spinner>
						</button>
					)}
				</div>
			</ModalFooter>
		</Modal>
	);
};

export default ReadyDispatchModal;
